// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"i_y","quicksight-embedding-iframe":"i_z"};